import {
  FileTextOutlined,
  UploadOutlined,
  // UnorderedListOutlined,
} from '@ant-design/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { AppNavMenu } from '..';

export function useDocumentsAccess(): boolean {
  const { isEntitled } = useFeatureEntitlements('documents');
  return !!isEntitled;
}

export const useDocumentsNavMenus = (): AppNavMenu[] => {
  const hasAccess = useDocumentsAccess();

  if (!hasAccess) {
    return [];
  }

  return [
    {
      path: '/documents',
      title: 'Docs',
      icon: <FileTextOutlined />,
      submenu: [
        {
          path: '/documents/bundles',
          title: 'Uploads',
          icon: <UploadOutlined />,
        },
        // {
        //   path: '/documents/worklist',
        //   title: 'Worklist',
        //   icon: <UnorderedListOutlined />,
        // },
      ],
    },
  ];
};
